import { memo, ReactNode, useRef } from 'react'

import { IS_RTL_DIRECTION } from 'consts'
import Tooltip from 'components/Tooltip'

import * as Styled from './styled'

interface IProps {
  text?: string
  icon?: ReactNode
  onClick: (name: string) => void
  isActive: boolean
  name: string
  tabWidth: number
  areHoverStylesUnset?: boolean
  tooltipText?: string
}

const FlatTab: React.FC<IProps> = ({
  text,
  icon,
  onClick,
  isActive,
  name,
  tabWidth,
  areHoverStylesUnset,
  tooltipText
}) => {
  const tabRef = useRef<HTMLDivElement | null>(null)

  const tab = (
    <Styled.FlatTab
      ref={tabRef}
      onClick={() => onClick(name)}
      $tabWidth={tabWidth}
      $isActive={isActive}
      $isRTLDirection={IS_RTL_DIRECTION}
      $areHoverStylesUnset={areHoverStylesUnset}
    >
      {icon && <Styled.IconWrap $isActive={isActive}>{icon}</Styled.IconWrap>}
      {text && (
        <Styled.Text
          color={isActive ? 'primary' : 'textSecondary'}
          type={isActive ? 'h3' : 'h4'}
          $isActive={isActive}
        >
          {text}
        </Styled.Text>
      )}
    </Styled.FlatTab>
  )

  if (!tooltipText) return tab

  return <Tooltip tooltipText={tooltipText}>{tab}</Tooltip>
}

export default memo(FlatTab)
